export const Role = {
    ADMIN: 'ROLE_ADMIN',
    CLIENTMANAGER: 'ROLE_CLIENT_MANAGER',
}